import { graphql } from 'gql.tada'

/**
 * Common queries
 */

export const InviteEmailMutation = graphql(`
  mutation InviteEmailMutation($input: InviteInput!) {
    invite(input: $input) {
      errors {
        ... on BaseError {
          field
          message
        }
      }
    }
  }
`)

export const SignInMutation = graphql(`
  mutation SignInMutation($input: SignInInput!) {
    signIn(input: $input) {
      authentication {
        accessToken
        refreshToken
        fingerprint
      }

      errors {
        ... on WrongEmailOrPassword {
          field
          message
        }
        ... on BaseError {
          field
          message
        }
      }
    }
  }
`)

export const PlayerQuery = graphql(`
  query PlayerQuery($id: ID!) {
    node(id: $id) {
      ... on Player {
        __typename
        id
        nickname
        avatarId
        playerAvatar {
          svg
        }
      }
    }
  }
`)

export const LatestContractsQuery = graphql(`
  query LatestContracts {
    latestContracts {
      id
      content
      contractType
      signed
      title
      version
    }
  }
`)

export const ContractSignMutation = graphql(`
  mutation ContractSignMutation($input: ContractSignInput!) {
    contractSign(input: $input) {
      contract {
        id
        signed
      }
      errors {
        ... on BaseError {
          field
          message
        }
      }
    }
  }
`)

export const ProfileSetupMutation = graphql(`
  mutation ProfileSetupMutation($input: ProfileSetupInput!) {
    profileSetup(input: $input) {
      viewer {
        id
        firstName
        lastName
      }
    }
  }
`)

export const PasswordForgotMutation = graphql(`
  mutation PasswordForgotMutation($input: PasswordForgotInput!) {
    passwordForgot(input: $input) {
      errors {
        ... on BaseError {
          field
          message
        }
      }
    }
  }
`)

export const PasswordForgotConfirmMutation = graphql(`
  mutation PasswordForgotConfirmMutation($input: PasswordForgotConfirmInput!) {
    passwordForgotConfirm(input: $input) {
      errors {
        ... on VerificationCodeInvalid {
          __typename
          field
        }
        ... on LimitExceededError {
          __typename
          field
        }
        ... on BaseError {
          __typename
          field
        }
      }
    }
  }
`)

export const ProfilePasswordUpdateMutation = graphql(`
  mutation ProfilePasswordUpdateMutation($input: ProfilePasswordUpdateInput!) {
    profilePasswordUpdate(input: $input) {
      errors {
        ... on PasswordInvalid {
          field
          message
        }
        ... on BaseError {
          field
          message
        }
      }
    }
  }
`)

export const ProfileNameUpdateMutation = graphql(`
  mutation ProfileNameUpdateMutation($input: ProfileNameUpdateInput!) {
    profileNameUpdate(input: $input) {
      viewer {
        id
        firstName
        lastName
      }
      errors {
        ... on BaseError {
          field
          message
        }
      }
    }
  }
`)

export const SignOutMutation = graphql(`
  mutation SignOutMutation($refreshToken: String!) {
    signOut(input: { refreshToken: $refreshToken }) {
      errors {
        ... on BaseError {
          field
          message
        }
      }
    }
  }
`)

export const LicenseCodeCheckMutation = graphql(`
  mutation LicenseCodeCheckMutation($input: LicenseCodeCheckInput!) {
    licenseCodeCheck(input: $input) {
      product {
        name
      }
    }
  }
`)

export const SchoolCodeCheckMutation = graphql(`
  mutation SchoolCodeCheckMutation($input: SchoolCodeCheckInput!) {
    schoolCodeCheck(input: $input) {
      valid
      schoolName
      verificationFields
      errors {
        ... on BaseError {
          __typename
          field
        }
      }
    }
  }
`)
